import { Dispatch, SetStateAction } from "react";

export function updateSingleState<T, TKey extends keyof T>(setState: Dispatch<SetStateAction<T>>, key: TKey, value: T[TKey]) {
  setState((prev) => {
    if (!prev) return prev;

    return {
      ...prev,
      [key]: value,
    };
  });
}

export function updateSingleNullableState<T, TKey extends keyof T>(setState: Dispatch<SetStateAction<T | (T | undefined)>>, key: TKey, value: T[TKey]) {
  setState((prev) => {
    if (!prev) return prev;

    return {
      ...prev,
      [key]: value,
    };
  });
}

export function updateArrayState<T, TKey1 extends keyof T, TKey2 extends keyof T>(
  setState: Dispatch<SetStateAction<T[]>>,
  key: TKey1,
  value: T[TKey1],
  identifierKey: TKey2,
  identifierValue: T[TKey2]
) {
  setState((prev) => {
    if (!prev) return prev;

    const copyArray = [...prev];

    const targetIndex = copyArray.findIndex((item) => item[identifierKey] === identifierValue);

    if (targetIndex === -1) return prev;

    const newItem = {
      ...prev[targetIndex],
      [key]: value,
    };

    copyArray.splice(targetIndex, 1, newItem);

    return copyArray;
  });
}
